import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { matrimonyApi } from '../matrimonyApi';
import { useAuth } from '../AuthContext';

export default function MatrimonyLogin() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return setError('Email and password are required');
    setError('');
    setLoading(true);
    try {
      await matrimonyApi.login({ email, password });
      await refresh();
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-auth-wrap">
      <div className="m-auth-card">
        <span className="m-auth-icon">💑</span>
        <h1 className="m-auth-title">Welcome Back</h1>
        <p className="m-auth-subtitle">Sign in to your SmaBizZ Matrimony account</p>

        {error && <div className="m-alert m-alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="m-form-group">
            <label className="m-form-label">Email Address</label>
            <input
              className="m-form-control"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="m-form-group">
            <label className="m-form-label">Password</label>
            <input
              className="m-form-control"
              type="password"
              placeholder="Your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="m-btn m-btn-primary m-btn-full m-btn-lg"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? 'Signing in…' : '🔐 Sign In'}
          </button>
        </form>

        <div className="m-divider-text" style={{ marginTop: 24 }}>
          <span>New to SmaBizZ Matrimony?</span>
        </div>
        <Link to="/register" className="m-btn m-btn-outline m-btn-full">
          🌹 Register Free
        </Link>
        <div style={{ textAlign: 'center', marginTop: 14 }}>
          <Link to="/" style={{ fontSize: 13, color: 'var(--m-muted)' }}>← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
